// Core
import React from 'react'

// Components, services, etc
import {deleteWallet} from 'actions/walletActions'
import ConfirmationModal from 'components/ConfirmationModal'
import {useAppDispatch} from 'services/store'

type Props = {
  open: boolean
  handleClose: () => void
  handleExited: () => void
}

const DeleteCardConfirmationModal = (props: Props) => {
  const dispatch = useAppDispatch()
  const handleDeleteCard = () => dispatch(deleteWallet())

  return (
    <ConfirmationModal
      title='Remove Card'
      content='Are you sure you want to delete this card? You won’t be able to order any new products unless you add a payment method.'
      onConfirm={handleDeleteCard}
      sqaPrefix='remove-card'
      onConfirmLoading='Removing Card'
      onConfirmText='Remove Card'
      {...props}
    />
  )
}

export default DeleteCardConfirmationModal
